module.exports = __webpack_public_path__ + "img/card4.298c949e.png";